import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-social-links',
  templateUrl: './edit-social-links.component.html',
  styleUrls: ['./edit-social-links.component.scss']
})
export class EditSocialLinksComponent implements OnInit {
formData: any = {
  name: '',
  url: '',
  image: null
};
urlError: string | null = null;

// Declare formData property 
    public arrCountries:any[] = [];
    public country:any[] = [];
  imagePreview: string | ArrayBuffer | null = null;
bookFileName: string | null = null;
    constructor(private router: Router, private apisService: ApisService,
        private route: ActivatedRoute
    ) { }
  
    ngOnInit(): void {
      // this.postCountires();
    const bookId = this.route.snapshot.paramMap.get('id');
  if (bookId) {
    this.fetchBookForEdit(+bookId);
  }
    }
  fetchBookForEdit(id: number): void {
  this.apisService.getSocialLinksById(id).subscribe({
    next: (user) => {
      const data = user.data;
      this.formData.name = data.name;
      this.formData.url = data.url;
      this.imagePreview = data.image; // Show existing image
    },
    error: (err) => {
      console.error('Error fetching :', err);
    },
  });
}


    cancel(): void {
      this.router.navigate(['/social-links']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    fetchUserForEdit(id: number): void {
  this.apisService.getSocialLinksById(id).subscribe({
    next: (res) => {
      const user = res.data;
      this.formData.name = user.name;
      this.formData.url = user.url;
      this.imagePreview = user.image;

    },
    error: (err) => {
      console.error('Error fetching :', err);
    }
  });
}



onFileSelected(event: Event, type: 'img' | 'book'): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const file = input.files[0];
    if (type === 'img') {
      this.formData.image = file;

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
}



submitForm(): void {
  const formDataToSend = new FormData();

  formDataToSend.append('name', this.formData.name);
  formDataToSend.append('url', this.formData.url);
  formDataToSend.append('image', this.formData.image);
  const id = this.route.snapshot.paramMap.get('id');

  this.apisService.editSocialLinks(+id, formDataToSend).subscribe({
    next: (res) => {
      Swal.fire('Success', ' saved successfully', 'success');
      this.router.navigate(['/social-links']);
    },
    error: (err) => {
      console.error('Upload error:', err);
      Swal.fire('Error', 'Please fix the errors and try again.', 'error');
    }
  });
}

//  getTranslation(translations: any[], locale: string) {
//       return translations.find(translation => translation.locale === locale) || {};
//     }

normalizeUrl() {
  if (!this.formData.url) {
    this.urlError = null;
    return;
  }

  // add https:// automatically
  if (
    !this.formData.url.startsWith('http://') &&
    !this.formData.url.startsWith('https://')
  ) {
    this.formData.url = 'https://' + this.formData.url;
  }

  // validate after normalize
  this.urlError = this.isValidUrl(this.formData.url)
    ? null
    : 'The url field must be a valid URL.';
}

isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

}
